import { AsyncPipe } from "@angular/common";
import { Component, inject } from "@angular/core";
import { CoreIcon } from "@svs/angular";
import { AuthService } from "../../@core/auth/auth.service";
import {
  MaintenanceDisclaimerComponent
} from "../../chat/landing/maintenance-disclaimer/maintenance-disclaimer.component";
import { OfflineDisclaimerComponent } from "../../chat/landing/offline-disclaimer/offline-disclaimer.component";

@Component({
  selector: 'app-auth-token-loader',
  imports: [
    AsyncPipe,
    CoreIcon,
    OfflineDisclaimerComponent,
    MaintenanceDisclaimerComponent,
  ],
  templateUrl: './auth-token-loader.component.html',
  styleUrl: './auth-token-loader.component.css'
})
export class AuthTokenLoaderComponent {
  authService = inject(AuthService);

}
